module.exports = __webpack_public_path__ + "static/the-essential-writings-of-ralph-waldo-emerson-89763c220b5c3bf055864414f4223de7.jpg";